// extracted by mini-css-extract-plugin
export var section = "_1m-1";
export var topNav = "_1m-0";